"use strict";

require("core-js/modules/es.object.assign.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _ModalModule = _interopRequireDefault(require("../styles/components/Modal.module.css"));
var _index = require("./index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 400,
  bgcolor: 'background.paper'
  // p: 3,
};

const Modal = props => {
  const {
    onClose,
    open,
    children,
    header = '',
    id = null,
    boxId = null,
    titleTypographyProps,
    theme = {},
    showCloseBtn = true,
    animationSize = false,
    classNameBox = 'flex-column',
    cardProps = {}
  } = props;
  return /*#__PURE__*/_react.default.createElement(_material.Modal, {
    id: id,
    "aria-labelledby": "transition-modal-title",
    "aria-describedby": "transition-modal-description",
    open: open,
    onClose: onClose,
    closeAfterTransition: true,
    BackdropComponent: _material.Backdrop,
    BackdropProps: {
      timeout: 500
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Fade, {
    in: open
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {}
  }, /*#__PURE__*/_react.default.createElement(_index.Card, _extends({
    id: boxId,
    sx: cardProps.sx ? _objectSpread(_objectSpread({}, style), cardProps.sx) : style,
    title: header,
    showCloseBtn: showCloseBtn,
    className: "".concat(_ModalModule.default.box, " ").concat(classNameBox),
    onClose: onClose,
    theme: _objectSpread({
      boxShadow: 'none'
    }, theme),
    titleTypographyProps: titleTypographyProps,
    animationSize: animationSize
  }, cardProps), children))));
};
var _default = exports.default = Modal;